function triggerFormSubmit(formName) {
    const form = document.forms[formName];
    if (form) {
        form.submit();

    } else {
        console.error("Form with name '" + formName + "' not found.");
    }
}

const formatTime = function (time) {
    return [
        Math.floor((time % 3600) / 60), // minutes
        ('00' + Math.floor(time % 60)).slice(-2) // seconds
    ].join(':');
};

const collapseSidebarBtn = document.getElementById('collapse-sidebar-btn');
if (collapseSidebarBtn) {
    collapseSidebarBtn.addEventListener('click', function (event) {
        event.preventDefault();
        document.getElementById('sidebar').classList.toggle('minimize');
    })
}

const navBarToggle = document.getElementById('header-navbar-toggler');
if (navBarToggle) {
    navBarToggle.addEventListener('click', function (event) {
        document.getElementById('sidebar').classList.toggle('show');
    })
}

const dropdownToggles = document.querySelectorAll('.navbar-nav .dropdown-toggle');

if (dropdownToggles) {
    dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
            const toggleBounds = toggle.getBoundingClientRect();
            const clickX = event.clientX;

            const iconWidth = 20;
            const isOnIcon = clickX > (toggleBounds.right - iconWidth);

            if (isOnIcon) {
                event.preventDefault();
                const parentItem = toggle.closest('.nav-item.dropdown');
                const dropdownMenu = parentItem.querySelector('.dropdown-menu');
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

                toggle.setAttribute('aria-expanded', !isExpanded);
                dropdownMenu.classList.toggle('active', !isExpanded);
                dropdownMenu.classList.toggle('show', !isExpanded);
            } else {
                return;
            }
        });
    });
}


document.addEventListener('DOMContentLoaded', function () {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(el => {
        new bootstrap.Tooltip(el, { delay: { show: 0, hide: 0 } });
    });
});

window.initSidebarTooltips = function() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(el => {
        new bootstrap.Tooltip(el, { delay: { show: 0, hide: 0 } });
    });
};

// Initialize tooltips on page load for static elements
if (window.$) {
  window.$(function() {
    window.initSidebarTooltips();
  });
}
